







// import React, { useState, useEffect } from "react";
// import { Card, CardHeader, CardTitle, CardContent } from "./Card";
// import { Dialog, DialogTitle } from "./DialogBox";
// import { FaExternalLinkAlt } from "react-icons/fa";
// import { MdBorderHorizontal } from "react-icons/md";

// const JobSeekerNotification = ({ jobSeeker }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       if (!jobSeeker) {
//         setNotifications([]);
//         return;
//       }

//       const notifs = [
//         ...(jobSeeker.appliedJobs
//           ? jobSeeker.appliedJobs
//               .filter(app => 
//                 ["applied", "shortlisted", "interviewed", "rejected", "offer", "accepted"]
//                   .map(s => s.toLowerCase())
//                   .includes(app?.status?.toLowerCase())
//               )
//               .map(app => ({
//                 type: app.status?.toLowerCase(),
//                 companyName: app.companyId?.companyName || "N/A",
//                 address: app.companyId?.address || "N/A",
//                 position: app.position || "N/A",
//                 jobId: app._id,
//                 createdAt: app.createdAt || new Date(),
//                 reasonForRejection: app.reasonForRejection || "N/A",
//                 dateHired: app.dateHired || null,
//               }))
//           : []),
//       ];
//       setNotifications(notifs);
//     };
//     fetchNotifications();
//   }, [jobSeeker]);

//   console.log(notifications)
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedNotification(null);
//   };

//   const handleViewDetails = (notification) => {
//     setSelectedNotification(notification);
//     setIsModalOpen(true);
//     console.log("Job Details:", {
//       companyName: notification.companyName,
//       companyAddress: notification.companyAddress,
//       position: notification.position,
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "applied":
//       case "shortlisted":
//         return "bg-yellow-100 text-yellow-800";
//       case "interviewed":
//         return "bg-purple-100 text-purple-800";
//       case "rejected":
//         return "bg-red-100 text-red-800";
//       case "offer":
//       case "accepted":
//         return "bg-green-100 text-green-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const getInterviewDate = (createdAt) => {
//     const date = new Date(createdAt);
//     date.setDate(date.getDate() + 7);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   return (
//     // <Card className="w-full max-w-md">
//     <>
//      <CardHeader className ="flex flex-wrap">
//         <CardTitle className="text-xl font-semibold text-[#1E3A8A]">
//           Notifications ({notifications.length})
//         </CardTitle>
//       </CardHeader>
//       <CardContent>
//         {notifications.length === 0 ? (
//           <p className="text-gray-500">
//             {jobSeeker ? "No new notifications." : "Loading job seeker data..."}
//           </p>
//         ) : (
//           <div className="flex flex-wrap gap-2">
//             {notifications.map((notification, index) => (
//               <div
//                 key={index}
//                 className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors flex-1 min-w-[250px]"
//               >
//                 <h4 className="font-semibold text-[#1E3A8A]">
//                   {notification.type === "shortlisted" && "Shortlisted for Interview"}
//                   {notification.type === "interviewed" && "Interview Scheduled"}
//                   {notification.type === "rejected" && "Application Rejected"}
//                   {notification.type === "offer" && "Job Offer"}
//                   {notification.type === "accepted" && "Job Accepted"}
//                   {notification.type === "applied" && "Application Submitted"}
//                 </h4>
//                 <p className="text-sm text-gray-600">
//                   {notification.companyName} - {notification.position}
//                 </p>
//                 <p className="text-xs text-gray-500">
//                   {new Date(notification.createdAt).toLocaleDateString()}
//                 </p>
//                 <button
//                   onClick={() => handleViewDetails(notification)}
//                   className="mt-2 inline-flex items-center px-3 py-1 bg-[#F97316] text-white rounded-md hover:bg-[#EA580C] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F97316]"
//                 >
//                   <MdBorderHorizontal className="w-4 h-4 mr-1" />
//                   View Letter
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}

//         <Dialog isOpen={isModalOpen} onClose={handleCloseModal}>
//           {selectedNotification && (
//             <>
//               <DialogTitle>
//                 {selectedNotification.type === "shortlisted" && "Letter of Invitation for Interview"}
//                 {selectedNotification.type === "interviewed" && "Interview Appointment Letter"}
//                 {selectedNotification.type === "rejected" && "Rejection Letter"}
//                 {selectedNotification.type === "offer" && "Placement Letter"}
//                 {selectedNotification.type === "accepted" && "Acceptance Confirmation"}
//                 {selectedNotification.type === "applied" && "Application Acknowledgment"}
//               </DialogTitle>
//               <div className="space-y-4 p-4 bg-white border border-gray-200 rounded-lg">
//                 <div className="text-center">
//                   <h3 className="font-semibold text-lg">
//                     {selectedNotification.type === "shortlisted" && "LETTER OF INVITATION FOR AN INTERVIEW"}
//                     {selectedNotification.type === "interviewed" && "INTERVIEW APPOINTMENT LETTER"}
//                     {selectedNotification.type === "rejected" && "REJECTION LETTER"}
//                     {selectedNotification.type === "offer" && "PLACEMENT LETTER"}
//                     {selectedNotification.type === "accepted" && "ACCEPTANCE CONFIRMATION"}
//                     {selectedNotification.type === "applied" && "APPLICATION ACKNOWLEDGMENT"}
//                   </h3>
//                   <p className="text-sm text-gray-500">{selectedNotification.companyName}</p>
//                   <p className="text-sm text-gray-500">Nigeria</p>
//                 </div>
//                 {/* <div className="flex justify-between mb-4">
//                   <p>INTERVIEW TIME: ____________________</p>
//                   <p>INTERVIEW DATE: ____________________</p>
//                 </div>
//                 <div className="flex justify-between mb-4">
//                   <p>Miss/Mr/Mrs. ____________________</p>
//                   <p>Reg ____________________</p>
//                 </div> */}
//                 {selectedNotification.type === "shortlisted" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     After a careful review of your C.V. and profile, you are hereby invited for a virtual or onsite interview on the ____________________. Please have other possible documents not listed on your profile that can warrant you the job readily available - like reference letter etc. and you are expected to dress formal or to be in the company’s official uniform which is a white shirt and black. Coloured or dyed hair is not allowed and hope to see you as expected while we thank you for optimizing your profile enough to easily find you. For more information about us, visit www.joblink.ng.
//                   </p>
//                 )}
//                 {selectedNotification.type === "interviewed" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     After a successful interview, you are hereby invited to resume your Quick 2-week Training at Autograph Hotel, {selectedNotification.address} for the position of {selectedNotification.position} with {selectedNotification.companyName}. Please find the details below:
//                     <ul className="list-disc pl-5 mt-2 text-sm text-gray-700">
//                       <li>Appointment Date: {getInterviewDate(selectedNotification.createdAt)}</li>
//                       <li>Time: 10:00 AM - 11:00 AM WAT</li>
//                       <li>Location: Autograph Hotel, {selectedNotification.address}</li>
//                     </ul>
//                     Please be expected to dress formal or to be in the company’s official uniform which is a white shirt and black trousers. Please consider your self part of the period of employment has record to grading would be taken of your performance and this reflect on your certificate.
//                   </p>
//                 )}
//                 {selectedNotification.type === "rejected" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     We regret to inform you that your application for the position of {selectedNotification.position} at {selectedNotification.companyName}, located at {selectedNotification.address}, has been rejected. The reason for rejection is: {selectedNotification.reasonForRejection}.
//                   </p>
//                 )}
//                 {selectedNotification.type === "offer" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     We are pleased to offer you the position of {selectedNotification.position} at {selectedNotification.companyName}, located at {selectedNotification.address}. Please find the details below:
//                     <ul className="list-disc pl-5 mt-2 text-sm text-gray-700">
//                       <li>Appointment Date: {getInterviewDate(selectedNotification.createdAt)}</li>
//                       <li>Time: 10:00 AM - 11:00 AM WAT</li>
//                       <li>Location: {selectedNotification.companyAddress}</li>
//                     </ul>
//                   </p>
//                 )}
//                 {selectedNotification.type === "accepted" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     Congratulations! Your acceptance for the position of {selectedNotification.position} at {selectedNotification.companyName}, located at {selectedNotification.address}, has been confirmed. Your start date is {selectedNotification.dateHired || getInterviewDate(selectedNotification.createdAt)}.
//                   </p>
//                 )}
//                 {selectedNotification.type === "applied" && (
//                   <p className="text-sm text-gray-700 mt-2">
//                     Your application for the position of {selectedNotification.position} at {selectedNotification.companyName}, located at {selectedNotification.address}, has been received and is under review.
//                   </p>
//                 )}
//                 <p className="text-sm text-gray-700 mt-2">Yours faithfully,</p>
//                 <p className="text-sm text-gray-700 mt-2">Human Resources.</p>
//                 <div className="flex justify-end mt-4">
//                   <button
//                     onClick={handleCloseModal}
//                     className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 mr-2"
//                   >
//                     Close
//                   </button>
//                   <button
//                     onClick={() =>
//                       (window.location.href = `/${selectedNotification.jobId}/applicationStatus`)
//                     }
//                     className="px-4 py-2 bg-[#F97316] text-white rounded-md hover:bg-[#EA580C]"
//                   >
//                     Accept
//                   </button>
//                 </div>
//               </div>
//             </>
//           )}
//         </Dialog>
//       </CardContent>

//     </>
     
//     // </Card>
//   );
// };

// export default JobSeekerNotification;





import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { Card, CardHeader, CardTitle, CardContent } from "./Card";
import { Dialog, DialogTitle } from "./DialogBox";
import { MdBorderHorizontal } from "react-icons/md";

const JobSeekerNotification = ({ jobSeeker }) => {
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAllNotifications = async () => {
      if (!jobSeeker?._id) return;

      setLoading(true);

      try {
        // 1. Status-based notifications from appliedJobs (your existing logic)
        const statusNotifs = (jobSeeker.appliedJobs || [])
          .filter(app =>
            ["applied", "shortlisted", "interviewed", "rejected", "offer", "accepted"].includes(
              app?.status?.toLowerCase()
            )
          )
          .map(app => ({
            _id: `status-${app._id}`, // fake id to avoid conflict
            type: app.status?.toLowerCase(),
            source: "application_status",
            companyName: app.companyId?.companyName || "N/A",
            address: app.companyId?.address || "N/A",
            position: app.position || "N/A",
            jobId: app._id, // application id here
            createdAt: app.createdAt || new Date(),
            reasonForRejection: app.reasonForRejection || "N/A",
            dateHired: app.dateHired || null,
          }));

        // 2. Real notification letters sent by employers
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}notification/jobseeker/my-notifications`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(res.data)

        const realLetters = (res.data.data || []).map(notif => ({
          _id: notif._id,
          type: notif.type,
          source: "employer_letter",
          companyName: notif.sender?.companyName || "Employer",
          position: notif.application?.position || "N/A",
          message: notif.message,
          title: notif.title,
          createdAt: notif.createdAt,
          // Add more fields if needed (e.g. actionUrl, metadata)
        }));

        // Combine both types of notifications
        const combined = [...statusNotifs, ...realLetters].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setNotifications(combined);
      } catch (err) {
        console.error("Failed to load notifications:", err);
        toast.error("Could not load some notifications");
      } finally {
        setLoading(false);
      }
    };

    fetchAllNotifications();
  }, [jobSeeker]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedNotification(null);
  };

  const handleViewDetails = (notification) => {
    setSelectedNotification(notification);
    setIsModalOpen(true);
  };

  const getInterviewDate = (createdAt) => {
    const date = new Date(createdAt);
    date.setDate(date.getDate() + 7);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <>
      <CardHeader className="flex flex-wrap">
        <CardTitle className="text-xl font-semibold text-[#1E3A8A]">
          Notifications {loading ? "(loading...)" : `(${notifications.length})`}
        </CardTitle>
      </CardHeader>

      <CardContent>
        {loading ? (
          <p className="text-gray-500 text-center py-8">Loading your notifications...</p>
        ) : notifications.length === 0 ? (
          <p className="text-gray-500">
            {jobSeeker ? "No notifications at the moment." : "Loading job seeker data..."}
          </p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {notifications.map((notification) => (
              <div
                key={notification._id}
                className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors flex-1 min-w-[250px]"
              >
                <h4 className="font-semibold text-[#1E3A8A]">
                  {/* Status-based notifications */}
                  {notification.source === "application_status" &&
                    notification.type === "shortlisted" &&
                    "Shortlisted for Interview"}
                  {notification.source === "application_status" &&
                    notification.type === "interviewed" &&
                    "Interview Scheduled"}
                  {notification.source === "application_status" &&
                    notification.type === "rejected" &&
                    "Application Rejected"}
                  {notification.source === "application_status" &&
                    notification.type === "offer" &&
                    "Job Offer"}
                  {notification.source === "application_status" &&
                    notification.type === "accepted" &&
                    "Job Accepted"}
                  {notification.source === "application_status" &&
                    notification.type === "applied" &&
                    "Application Submitted"}

                  {/* Real letters from employer */}
                  {notification.source === "employer_letter" && (notification.title || "Message from Employer")}
                </h4>

                <p className="text-sm text-gray-600 mt-1">
                  {notification.companyName} • {notification.position}
                </p>

                <p className="text-xs text-gray-500 mt-1">
                  {new Date(notification.createdAt).toLocaleDateString()}
                </p>

                <button
                  onClick={() => handleViewDetails(notification)}
                  className="mt-3 inline-flex items-center px-3 py-1 bg-[#F97316] text-white rounded-md hover:bg-[#EA580C] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F97316]"
                >
                  <MdBorderHorizontal className="w-4 h-4 mr-1" />
                  View Letter
                </button>
              </div>
            ))}
          </div>
        )}

        <Dialog isOpen={isModalOpen} onClose={handleCloseModal}>
          {selectedNotification && (
            <>
              <DialogTitle>
                {/* Status-based titles */}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "shortlisted" &&
                  "Letter of Invitation for Interview"}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "interviewed" &&
                  "Interview Appointment Letter"}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "rejected" &&
                  "Rejection Letter"}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "offer" &&
                  "Placement / Offer Letter"}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "accepted" &&
                  "Acceptance Confirmation"}
                {selectedNotification.source === "application_status" &&
                  selectedNotification.type === "applied" &&
                  "Application Acknowledgment"}

                {/* Real employer letter */}
                {selectedNotification.source === "employer_letter" &&
                  (selectedNotification.title || "Message from Employer")}
              </DialogTitle>

              <div className="space-y-4 p-4 bg-white border border-gray-200 rounded-lg">
                <div className="text-center">
                  <h3 className="font-semibold text-lg">
                    {selectedNotification.source === "application_status" &&
                      selectedNotification.type === "shortlisted" &&
                      "LETTER OF INVITATION FOR AN INTERVIEW"}
                    {/* ... other status titles ... */}
                    {selectedNotification.source === "employer_letter" &&
                      selectedNotification.title?.toUpperCase()}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {selectedNotification.companyName || "—"}
                  </p>
                  <p className="text-sm text-gray-500">Nigeria</p>
                </div>

                {/* Real letter content from employer */}
                {selectedNotification.source === "employer_letter" && (
                  <div className="text-sm text-gray-700 mt-4 whitespace-pre-line leading-relaxed">
                    {selectedNotification.message || "No message content available."}
                  </div>
                )}

                {/* Keep your existing conditional content for status-based notifications */}
                {selectedNotification.source === "application_status" && (
                  <>
                    {selectedNotification.type === "shortlisted" && (
                      <p className="text-sm text-gray-700 mt-2">
                        After a careful review of your C.V. and profile, you are hereby invited for a
                        virtual or onsite interview on the ____________________. Please have other
                        possible documents not listed on your profile...
                      </p>
                    )}
                    {selectedNotification.type === "interviewed" && (
                      <p className="text-sm text-gray-700 mt-2">
                        After a successful interview, you are hereby invited to resume your Quick
                        2-week Training at Autograph Hotel, {selectedNotification.address}...
                      </p>
                    )}
                    {selectedNotification.type === "rejected" && (
                      <p className="text-sm text-gray-700 mt-2">
                        We regret to inform you that your application for the position of{" "}
                        {selectedNotification.position} at {selectedNotification.companyName}...
                        Reason: {selectedNotification.reasonForRejection}
                      </p>
                    )}
                    {/* ... keep other cases ... */}
                  </>
                )}

                <p className="text-sm text-gray-700 mt-4">Yours faithfully,</p>
                <p className="text-sm text-gray-700">Human Resources.</p>

                <div className="flex justify-end mt-6 gap-3">
                  <button
                    onClick={handleCloseModal}
                    className="px-5 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                  >
                    Close
                  </button>

                  {selectedNotification.source === "application_status" && (
                    <button
                      onClick={() =>
                        (window.location.href = `/${selectedNotification.jobId}/applicationStatus`)
                      }
                      className="px-5 py-2 bg-[#F97316] text-white rounded-md hover:bg-[#EA580C]"
                    >
                      View Status
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
        </Dialog>
      </CardContent>
    </>
  );
};

export default JobSeekerNotification;